import { deserialize } from 'cerialize'
import moment from 'moment'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'
import { REQUESTS } from 'Pages/logs'

export class PreRecordModel {
	@deserialize public id: number
	@deserialize public created_at: string
	@deserialize public partner_inn: string
	@deserialize public order_inn: string
	@deserialize public success: boolean
	@deserialize public info: REQUESTS
	@deserialize public response_code: number
	@deserialize public response_body: string
	@deserialize public request_body: string
	@deserialize public method: string
	@deserialize public url: string
	@deserialize public requestable_type?: string
	public get time_formatted(): string | undefined {
		return moment(this?.created_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}
}
